import { erpConfigQuery } from "@common/api/integrations"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { hasCorridorErp } from "./-lib/corridor"

export const Route = createFileRoute(
  "/_layout/settings/_panel/integrations/erp",
)({
  staticData: {
    breadcrumb: [
      { label: "Integrations" },
      { label: "ERP", href: "/settings/integrations/erp" },
    ],
  },
  beforeLoad: async ({ context: { queryClient } }) => {
    await requirePermission(
      queryClient,
      "erp_config:read",
      "/settings/workspace/general",
    )
    const config = await queryClient.ensureQueryData(erpConfigQuery())
    if (!hasCorridorErp(config)) {
      throw redirect({ to: "/settings/workspace/general" })
    }
  },
})
